export function composeAddressLabel(address) {
  let street = address.street || "";
  let street2 = address.street2 || "";
  let city = address.city;
  let zip = address.zip;
  let email = address.email || ''
  let firstPart = [street, street2].join(" ");
  let secondPart = [zip,city].join(" ")
  let thirdPard = [email]
  let addressLabel = [firstPart,secondPart,thirdPard].join(", ")
  return addressLabel;
}
